import React, { useEffect, useState } from 'react'
import { HabilitationAccordion } from '../access/HabilitationAccordion'
import { QUALITO } from '../../../constants/ApplicationHabilitationConstants'
import i18n from '../../../../../../simple-react-i18n'
import QualityAction from '../../../../../../quality/actions/QualityAction'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import DtoQualitometerLight from '../../../../../../quality/dto/DtoQualitometerLight'

const HabilitationQualito = ({}) => {
    const dispatch = useDispatch()
    const {
        qualitometers,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
    }), shallowEqual)

    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        if (qualitometers.length === 0) {
            dispatch(QualityAction.fetchQualitometersLight()).then(() => setIsLoaded(true))
        } else {
            setIsLoaded(true)
        }
    }, [dispatch])

    return (
        <HabilitationAccordion
            stationType={QUALITO}
            title={i18n.quality}
            stations={qualitometers}
            isLoaded={isLoaded}
        />
    )
}

HabilitationQualito.propTypes = {
    qualitometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualitometerLight)),
    fetchQualitometersLight: PropTypes.func,
}

export default HabilitationQualito